import React, { useEffect, useState } from "react";
import { Grid, Button } from "@scuf/common";
import TitlePage from "../../components/TitlePage/TitlePage";
import AllActualDAPC from "../../components/Charts/DAPC/AllActualDAPC";
import TostacionDAPC from "../../components/Charts/DAPC/TostacionDAPC";
import TrenGasesDAPC from "../../components/Charts/DAPC/TrenGasesDAPC";
import PlantaAcidoDAPC from "../../components/Charts/DAPC/PlantaAcidoDAPC";

import "./DAPC.css";

const DAPC = () => {
  const [getdataT, setgetdataT] = useState([]);
  const [getdataTG, setgetdataTG] = useState([]);
  const [getdataPA, setgetdataPA] = useState([]);

  /// All valor actual
  useEffect(() => {
    const fData = async () => {
      setgetdataT(await AllActualDAPC.getDataT());
      setTimeout(() => {
        fData();
      }, 60000);
    };

    const fData2 = async () => {
      setgetdataTG(await AllActualDAPC.getDataTG());
      setTimeout(() => {
        fData();
      }, 60000);
    };

    const fData3 = async () => {
      setgetdataPA(await AllActualDAPC.getDataPA());
      setTimeout(() => {
        fData();
      }, 60000);
    };

    fData();
    fData2();
    fData3();
  }, []);

  const [stateBtn, setStateBtn] = useState({
    tostador: true,
    trenGases: false,
    plantaAcido: false,
  });

  return (
    <Grid className="mt-0 p-0">
      <Grid.Row>
        <TitlePage title="Detalle APC" />
      </Grid.Row>
      <Grid.Row>
        <Grid.Column sWidth="12" mWidth="12" width="4"></Grid.Column>
        <Grid.Column sWidth="12" mWidth="12" width="4">
          <div style={{ marginTop: "10px", textAlign: "center" }}>
            <Button.Group>
              <Button
                className="button-smaller btnHeaderHome px-3"
                type={stateBtn.tostador ? "primary" : "secondary"}
                onClick={() =>
                  setStateBtn({
                    tostador: true,
                    trenGases: false,
                    plantaAcido: false,
                  })
                }
                content="Tostación"
              />
              <Button
                className="button-smaller btnHeaderHome px-3"
                type={stateBtn.trenGases ? "primary" : "secondary"}
                onClick={() =>
                  setStateBtn({
                    tostador: false,
                    trenGases: true,
                    plantaAcido: false,
                  })
                }
                content="Tren de Gases"
              />
              <Button
                className="button-smaller btnHeaderHome px-3"
                type={stateBtn.plantaAcido ? "primary" : "secondary"}
                onClick={() =>
                  setStateBtn({
                    tostador: false,
                    trenGases: false,
                    plantaAcido: true,
                  })
                }
                content="Planta de Ácido"
              />
            </Button.Group>
          </div>
        </Grid.Column>
        <Grid.Column sWidth="12" mWidth="12" width="4"></Grid.Column>
      </Grid.Row>
      <Grid.Row>
        {stateBtn.tostador && getdataT.length > 0 ? (
          <TostacionDAPC height={645} getData={getdataT} />
        ) : stateBtn.trenGases && getdataTG.length > 0 ? (
          <TrenGasesDAPC height={800} getData={getdataTG} />
        ) : stateBtn.plantaAcido && getdataPA.length > 0 ? (
          <PlantaAcidoDAPC height={800} getData={getdataPA} />
        ) : (
          <div className="letter-origin">...No hay datos</div>
        )}
      </Grid.Row>
    </Grid>
  );
};

export default DAPC;
